interface TodayShiftProps {
  show?: boolean;
}

export default function TodayShift({ show = true }: TodayShiftProps) {
  if (!show) return null;

  const weekSchedule = [
    { day: 0, therapists: ['さくら', 'みう'] }, // 日
    { day: 1, therapists: ['みう', 'ひなの'] }, // 月
    { day: 2, therapists: ['さくら', 'れいな'] }, // 火
    { day: 3, therapists: ['ひなの', 'さくら'] }, // 水
    { day: 4, therapists: ['みう', 'れいな'] }, // 木
    { day: 5, therapists: ['みう', 'さくら'] }, // 金
    { day: 6, therapists: ['ひなの', 'れいな'] }, // 土
  ];

  const today = new Date().getDay();
  const todaySchedule = weekSchedule.find((s) => s.day === today);

  if (!todaySchedule) return null;

  return (
    <div className="bg-gradient-to-r from-pink-50 to-purple-50 border-2 border-pink-200 rounded-2xl p-6 mb-8">
      <div className="flex items-center justify-between flex-wrap gap-4">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 flex items-center justify-center bg-pink-500 text-white rounded-full">
            <i className="ri-calendar-check-line text-xl"></i>
          </div>
          <div>
            <h3 className="text-lg font-bold text-gray-800">本日の出勤</h3>
            <p className="text-sm text-gray-500">11:00〜18:00</p>
          </div>
        </div>
        <div className="flex flex-wrap gap-2">
          {todaySchedule.therapists.map((name) => (
            <span key={name} className="inline-block px-4 py-2 bg-white text-pink-600 border-2 border-pink-300 rounded-full text-sm font-semibold whitespace-nowrap">
              {name}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}